import { Box, Flex } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

import { Condition } from 'Component/others';
import EmptyState from 'Component/empty-state';

import RankPodium from 'View/host-achievement-detail/component/rank-podium';
import UserRankCard from 'View/host-achievement-detail/component/user-rank-card';

import styles from './styles.module.css';

const Ranking = ({ userData, rankingData, isFetching }) => {
  const { t } = useTranslation('empty-state');
  return (
    <Box className={styles['ranking__container']}>
      <Condition
        statement={rankingData?.length || isFetching}
        fallback={<EmptyState title={t('no_data.title')} description={t('no_data.description')} className={styles['ranking__container--empty-state']} />}
      >
        <Flex justifyContent="center" alignItems="end" marginTop="30px">
          <RankPodium rankPosition={2} data={rankingData?.[1]} />
          <RankPodium rankPosition={1} data={rankingData?.[0]} />
          <RankPodium rankPosition={3} data={rankingData?.[2]} />
        </Flex>
        <UserRankCard data={userData} />
      </Condition>
    </Box>
  );
};

export default Ranking;
